import { PaginatedBookingColumnType } from './PaymentHistoryDataGrid'
import { amountColumnModel } from './columns/AmountColumn'
import { codeColumnModel } from './columns/CodeColumn'
import { createdAtColumnModel } from './columns/CreatedAtColumn'
import { paymentMethodColumnModel } from './columns/PaymentMethodColumn'

export const dataGridColumns: PaginatedBookingColumnType[] = [
  codeColumnModel,
  createdAtColumnModel,
  paymentMethodColumnModel,
  amountColumnModel
]
